// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Ansi837MedicalClaimResponseModel } from './ansi837MedicalClaimResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ClaimV1ClaimCreateAnsi837MedicalClaimResponse {
    'data': Ansi837MedicalClaimResponseModel | null;
    'success': boolean;
    'messages': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ClaimV1ClaimCreateAnsi837MedicalClaimResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "Ansi837MedicalClaimResponseModel"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return ClaimV1ClaimCreateAnsi837MedicalClaimResponse.attributeTypeMap;
    }
}
